module.exports = new __parcel__URL__("new-roadmap-darkmode.9b5479d5.svg").toString();